/**
 * Liste des marques de véhicules supportées et helper d'années admissibles.
 *
 * Exclusions explicites :
 *  - Jaguar, Land Rover (demande utilisateur)
 *  - Hypercars : Bugatti, Pagani, Koenigsegg, Rimac, McLaren, Ferrari,
 *    Lamborghini, Maserati, Aston Martin, Rolls-Royce, Bentley
 */
export const VEHICLE_BRANDS = [
  'Abarth',
  'Alfa Romeo',
  'Alpine',
  'Audi',
  'BMW',
  'BYD',
  'Cadillac',
  'Chevrolet',
  'Chrysler',
  'Citroën',
  'Cupra',
  'Dacia',
  'DS Automobiles',
  'Fiat',
  'Ford',
  'Genesis',
  'Honda',
  'Hyundai',
  'Infiniti',
  'Isuzu',
  'Iveco',
  'Jeep',
  'Kia',
  'Lancia',
  'Lexus',
  'Lotus',
  'Mazda',
  'Mercedes-Benz',
  'MG',
  'MINI',
  'Mitsubishi',
  'Nissan',
  'Opel',
  'Peugeot',
  'Polestar',
  'Porsche',
  'Renault',
  'SEAT',
  'Škoda',
  'Smart',
  'SsangYong',
  'Subaru',
  'Suzuki',
  'Tesla',
  'Toyota',
  'Volkswagen',
  'Volvo',
];

/**
 * Années admissibles : de 2000 à l'année courante.
 * @returns {number[]} liste décroissante (récent en haut)
 */
export const ELIGIBLE_YEARS = (() => {
  const current = new Date().getFullYear();
  const min = 2000;
  const out = [];
  for (let y = current; y >= min; y -= 1) out.push(y);
  return out;
})();
